/* global Vimeo */

document.addEventListener('DOMContentLoaded', function() {
    const ffSection = document.querySelectorAll('.fifty-fifty-section');

    ffSection.forEach(section => {
        section.querySelectorAll('.ff-media').forEach(function(element) {
            element.addEventListener('click', function() {
                const btn = this;
                const video = btn.querySelector('video.html5');
                const yt = btn.querySelector('iframe.youtube');
                const vimeo = btn.querySelector('iframe.vimeo');
                // var vidyard = btn.querySelector('.vidyard');

                if (btn.querySelector('.video-inner').classList.contains('html5')) {
                    if (video.paused) {
                        video.play();
                        btn.classList.add('player-start');
                        btn.classList.remove('player-pause');
                    } else {
                        video.pause();
                        btn.classList.add('player-pause');
                        btn.classList.remove('player-start');
                    }
                }

                if (btn.querySelector('.video-inner').classList.contains('youtube')) {
                    if (btn.classList.contains('player-start')) {
                        yt.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        btn.classList.add('player-pause');
                        btn.classList.remove('player-start');
                    } else {
                        yt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                        btn.classList.add('player-start');
                        btn.classList.remove('player-pause');
                    }
                }

                if (btn.querySelector('.video-inner').classList.contains('vimeo')) {
                    const vimeoPlayer = new Vimeo.Player(vimeo);
                    vimeoPlayer.getPaused().then(function(paused) {
                        if (paused) {
                            vimeoPlayer.play();
                            btn.classList.add('player-start');
                            btn.classList.remove('player-pause');
                        } else {
                            vimeoPlayer.pause();
                            btn.classList.add('player-pause');
                            btn.classList.remove('player-start');
                        }
                    });
                }

                // if (vidyard) {
                // 	var uuid = vidyard.dataset.uuid;
                // 	var players = VidyardV4.api.getPlayersByUUID(uuid);
                // 	players[0].play();

                // 	if (players && players.length > 0) {
                // 		var player = players[0];
                // 		var isPlaying = false;

                // 		// Add event listeners to track the play/pause state
                // 		player.on('play', function () {
                // 			isPlaying = true;
                // 			btn.classList.add('player-start');
                // 			btn.classList.remove('player-pause');
                // 		});

                // 		player.on('pause', function () {
                // 			isPlaying = false;
                // 		});
                // 	}
                // }
            });
        });
    });
});
